import { calculatePrecision, precisionRound } from "@uifabric/utilities";
import produce from "immer";
import {
  ChoiceGroup,
  Dropdown,
  IChoiceGroupOption,
  IDropdownOption,
  SpinButton,
  TextField
} from "office-ui-fabric-react";
import { Position } from "office-ui-fabric-react/lib/utilities/positioning";
import React from "react";

const onChange = (input: any) => (e: any) => input.onChange(e.target.value);

export const renderTextField = ({
  input,
  label,
  type,
  placeholder,
  className,
  underlined,
  maxLength,
  tabIndex,
  required,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  step,
  iconProps,
  meta: { touched, error }
}: any) => {
  return (
    <TextField
      {...input}
      label={label}
      placeholder={placeholder}
      type={type}
      className={className}
      underlined={underlined}
      maxLength={maxLength}
      tabIndex={tabIndex}
      required={required}
      min={min}
      max={max}
      step={step}
      iconProps={iconProps}
      errorMessage={touched && error && error}
      onChange={onChange(input)}
    />
  );
};

// noinspection JSUnusedGlobalSymbols
/**
 * https://github.com/OfficeDev/office-ui-fabric-react/issues/5326
 * @param input
 * @param label
 * @param type
 * @param maxLength
 * @param tabIndex
 * @param required
 * @param min
 * @param max
 * @param step
 * @param touched
 * @param error
 */
export const renderSpinButton = ({
  input,
  label,
  type,
  maxLength,
  tabIndex,
  required,
  min = 0,
  max = Number.MAX_SAFE_INTEGER,
  step,
  meta: { touched, error }
}: any) => {
  const precision = Math.max(calculatePrecision(step), 0);
  const onIncrement = (value: string) => {
    let newValue = Math.min(Number(value) + Number(step), max);
    newValue = precisionRound(newValue, precision);
    input.onChange(newValue);
    return newValue;
  };
  const onDecrement = (value: string) => {
    let newValue = Math.max(Number(value) - Number(step), min);
    newValue = precisionRound(newValue, precision);
    input.onChange(newValue);
    return newValue;
  };

  return (
    <SpinButton
      {...input}
      label={label}
      labelPosition={Position.top}
      placeholder={label}
      type={type}
      maxLength={maxLength}
      tabIndex={tabIndex}
      required={required}
      min={min}
      max={max}
      step={step}
      errorMessage={touched && error && error}
      styles={{
        labelWrapperTop: {
          height: "21px",
          marginTop: "5px",
          marginBottom: "5px"
        }
      }}
      onChange={onChange(input)}
      onIncrement={onIncrement}
      onDecrement={onDecrement}
    />
  );
};

export const renderDrowdown = ({
  options,
  CustomDropdown,
  customDropdownProps
}: {
  options?: IDropdownOption[] | undefined;
  // FIXME: なおす
  CustomDropdown?: React.ComponentType<any>;
  customDropdownProps?: any;
}) => {
  return ({
    input,
    label,
    tabIndex,
    required,
    className,
    meta: { touched, error }
  }: any) => {
    const o = produce(
      options || [],
      draft => void draft.splice(0, 0, { key: "", text: "" })
    );

    const onDropdownChange = (
      e: React.FormEvent<HTMLDivElement>,
      item?: IDropdownOption
    ) => {
      if (item) {
        input.onChange(item.key);
      }
    };

    if (CustomDropdown) {
      return (
        <CustomDropdown
          options={o}
          label={label}
          placeholder={label}
          tabIndex={tabIndex}
          required={required}
          selectedKey={input.value}
          errorMessage={touched && error}
          onChange={onDropdownChange}
          {...customDropdownProps}
        />
      );
    } else {
      return (
        <Dropdown
          options={o}
          label={label}
          placeholder={label}
          tabIndex={tabIndex}
          required={required}
          selectedKey={input.value}
          errorMessage={touched && error}
          onChange={onDropdownChange}
          className={className}
        />
      );
    }
  };
};

export const renderChoiceGroup = (options: IChoiceGroupOption[]) => ({
  input,
  label,
  tabIndex,
  required,
  defaultSelectedKey
}: any) => {
  const onChoiceGroupChange = (
    ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
    option?: IChoiceGroupOption
  ) => {
    if (option) {
      input.onChange(option.key);
    }
  };

  console.log({ defaultSelectedKey });

  return (
    <ChoiceGroup
      options={options}
      label={label}
      placeholder={label}
      tabIndex={tabIndex}
      required={required}
      // defaultSelectedKey={defaultSelectedKey}
      selectedKey={input.value}
      onChange={onChoiceGroupChange}
    />
  );
};
